// extracted by css-extract-rspack-plugin
export default {"anchor":"anchor-MNDaBa"};